import { Button, TYPE } from '@common/Button/Button';
import { useTranslation } from 'next-i18next';
import { Icon, IconColor, IconID } from '@common/Icon/Icon';
import classNames from 'classnames';
import styles from '../Default/BuyBox.module.scss';
import { EXTERNAL_LINKS } from '@libs/redirect.helper';
import { WidenImage } from '@common/Widen/WidenImage';
import { WidenUtil } from '@libs/widen-utils';
import { WidenImageConfig } from '@models/widen-image-config';
import { useRouter } from 'next/router';

interface ESkinInformationModalContentProps {
  onAddToShoppingCart: () => void;
}

export const ESkinInformationModalContent = ({ onAddToShoppingCart }: ESkinInformationModalContentProps) => {
  const { t } = useTranslation(['product/eSkinInformation', 'product/buyBox']);
  const { locale } = useRouter();

  const eSkinConfiguratorImageUrl = WidenUtil.getWidenCDNUrl(
    new WidenImageConfig('m4ccrmayu1', 'CF_GEN_cf_clean_e-skin_flat_v1.webp', 300, 300)
  );
  const eskinConfiguratorImage = {
    shortCode: WidenUtil.extractWidenImageId(eSkinConfiguratorImageUrl),
    fileName: WidenUtil.extractWidenImageName(eSkinConfiguratorImageUrl),
  };
  return (
    <div className={classNames(styles.ESkinInformationModalContent)}>
      <p className="mb-2 text-3xl font-bold">{t('E_SKIN_INFORMATION.TITLE')}</p>
      <p className="mb-8 pb-8 text-sm igus-text-styles border-b">{t('E_SKIN_INFORMATION.DETAILS')}</p>
      <a target="_blank" href={EXTERNAL_LINKS.E_SKIN_CONFIGURATOR(locale)} rel="noreferrer">
        <div className="flex igus-text-styles pb-8 mb-4 border-b">
          <div className="mr-4 items-center">
            <WidenImage
              width={75}
              height={50}
              alt={t('E_SKIN_INFORMATION.CONFIGURATOR.LINK_TITLE')}
              shortCode={eskinConfiguratorImage.shortCode}
              filename={eskinConfiguratorImage.fileName}
            />
          </div>
          <div>
            <p className="text-xl font-bold mb-2">{t('E_SKIN_INFORMATION.CONFIGURATOR.LINK_TITLE')}</p>
            <p className="text-sm text-gray-400">{t('E_SKIN_INFORMATION.CONFIGURATOR.LINK_DESCRIPTION')}</p>
          </div>
        </div>
      </a>
      <div className="flex justify-end" data-testid="eskin-modal-submit-button">
        <Button
          icon={<Icon size={10} color={IconColor.WHITE} id={IconID.CART} />}
          text={t('BUY_BOX.ADD_TO_CART', { ns: 'product/buyBox' })}
          type={TYPE.PRIMARY}
          onClick={() => onAddToShoppingCart()}
        />
      </div>
    </div>
  );
};
